import * as React from 'react';
import { enableRipple } from '@syncfusion/ej2-base';
import { loadingShow } from '../../App';
import Message from '../../utils/Message/Message';
import {
  DialogComponent,
  ButtonPropsModel,
  AnimationSettingsModel,
} from '@syncfusion/ej2-react-popups';
import { DataManager, Query, Predicate } from '@syncfusion/ej2-data';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {
  TreeViewComponent,
  ContextMenuComponent,
} from '@syncfusion/ej2-react-navigations';
import {
  getAssignments,
  getAssignmentsDetails,
} from '../../services/assignments/assignmentService';
import './style.css';
import { IoAddSharp, IoCheckmarkDoneOutline, IoRefresh, IoTrashOutline } from 'react-icons/io5';
import { GoPencil } from 'react-icons/go';
import { toast } from 'react-toastify';
import Scheduler from '../../components/GlobalScheduler';
import { ThemeContext } from '../../context/theme.context';
import { UploaderComponent } from '@syncfusion/ej2-react-inputs';
import defaultImage from '../../assets/images/DefaultImage.png';
import {
  addAssignment,
  editAssignment,
  deleteAssignment,
} from '../../services/assignments/assignmentService';
import TeamAndTradeSetter from '../../utils/TeamAndTradeSetter';
import GenerateCapacity from '../../utils/GenerateCapacity';
import { searchNodes } from '../../utils/GetFilterItems';
enableRipple(true);
interface IState {
  AssignmentData: any;
  fields: any;
  hideDialog: boolean;
  hideDialogAssignAdd: boolean;
  hideDialogAssignEdit: boolean;
  hideDialogAssignDelete: boolean;
  tradeTeamSetVisible: boolean;
  disabledAssignModal: boolean;
  selectedAssignments: Array<any>;
  isNoteMode: boolean;
}
interface IProps {}
class Assignments extends React.Component<IProps, IState> {
  public treeObj: TreeViewComponent;
  public menuObj: any;
  public index = 1;
  public menuItems: any;
  private buttonsAssignmentsDelete: ButtonPropsModel[];
  private animationSettings: AnimationSettingsModel;
  public dialogInstance: any;
  public buttonEle: any;
  public selectedName: string;
  private isChecked: boolean = true;
  checkedNodes: any;
  private assignmentId: string;
  public maskObj: TextBoxComponent;
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private addAssignName: string = '';
  private addAssignLastname: string = '';
  private editAssignName: string = '';
  private editAssignLastname: string = '';
  private assignmentIdEdit: number = -1;
  private assignmentIdDelete: number = -1;
  private assignmentIdsDelete: number[] = [];
  constructor(props: IProps) {
    super(props);
    this.treeObj = new TreeViewComponent(props);
    this.menuObj = new ContextMenuComponent(props);
    this.dialogInstance = new DialogComponent(props);
    this.maskObj = new TextBoxComponent(props);
    this.selectedName = '';
    this.assignmentId = '';
    this.buttonsAssignmentsDelete = [
      {
        click: () => {
          this.deleteAssignElement();
        },
        buttonModel: {
          content: 'Accept',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogAssignDelete: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };
    this.menuItems = [
      { text: 'Assign Shift Element' },
      { text: 'Assign Note' },
      { text: 'Set Teams Trades' },
    ];
    this.state = {
      AssignmentData: [],
      fields: {
        dataSource: [],
        id: '',
        text: '',
        hasChildren: '',
        selected: '',
      },
      hideDialog: false,
      hideDialogAssignAdd: false,
      tradeTeamSetVisible: false,
      hideDialogAssignDelete: false,
      hideDialogAssignEdit: false,
      disabledAssignModal: false,
      selectedAssignments: [],
      isNoteMode: false,
    };
  }
  addAssignElement() {
    this.setState({ disabledAssignModal: true });
    if (this.addAssignName === '') {
      this.setState({ disabledAssignModal: false });
      Message.error("Name mustn't be empty");
      return;
    }
    if (this.addAssignLastname === '') {
      this.setState({ disabledAssignModal: false });
      Message.error("Lastname mustn't be empty");
      return;
    }

    var full_name =
      this.addAssignName.trim() + ' ' + this.addAssignLastname.trim();
    const fullNameControl = full_name.replace(' ', '');
    const nameIfExists = this.state.AssignmentData.find(
      (x: any) =>
        x.alias_name.toLowerCase().replace(' ', '') ===
        fullNameControl.toLowerCase()
    );
    if (nameIfExists !== null && nameIfExists !== undefined) {
      this.setState({ disabledAssignModal: false });
      Message.error('The table of the same name already exists');
      return false;
    }
    loadingShow(true);
    let obj = {
      description: '',
      first_name: this.addAssignName,
      last_name: this.addAssignLastname,
      full_name: full_name,
      alias_name: full_name,
      image_url: '',
      is_mastered: false,
    };
    addAssignment(obj)
      .then((result) => {
        loadingShow(false);
        Message.success('Added successfully...');
        this.setState({
          hideDialogAssignAdd: false,
          disabledAssignModal: false,
        });
        this.context.setDataChange(true);
        this.getAssignments();
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Add failed!!!');
        this.setState({ disabledAssignModal: false });
      });
  }
  editAssignElement() {
    loadingShow(true);
    this.setState({ disabledAssignModal: true });
    var assignmentId = this.assignmentIdEdit;
    if (this.editAssignName === '') {
      this.setState({ disabledAssignModal: false });
      Message.error('Name cannot be empty');
      return;
    }
    if (this.editAssignLastname === '') {
      this.setState({ disabledAssignModal: false });
      Message.error('Lastname cannot be empty');
      return;
    }

    var full_name = this.editAssignName + ' ' + this.editAssignLastname;
    var first_name = this.addAssignName;
    var last_name = this.addAssignLastname;
    let obj = {
      description: '',
      first_name: this.editAssignName,
      last_name: this.editAssignLastname,
      full_name: full_name,
      alias_name: full_name,
      image_url: '',
      is_mastered: false,
      assignment_id: Number(assignmentId),
    };

    editAssignment(obj)
      .then((result) => {
        loadingShow(false);
        Message.success('Added successfully...');
        this.getAssignments();
        this.setState({
          hideDialogAssignEdit: false,
          disabledAssignModal: false,
        });
        //this.context.setDataChange(true);
        this.setTradeTeamAffected()
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Edit failed!!!');
        this.setState({ disabledAssignModal: false });
      });
  }
  deleteAssignElement() {
    // let obj = {
    //   assignment_id: Number(this.assignmentIdDelete),
    // };
    let obj = this.assignmentIdsDelete;

    deleteAssignment(obj)
      .then((result) => {
        loadingShow(false);
        Message.success('Deleted  successfully...');
        this.getAssignments();
        this.context.setDataChange(true);
        this.assignmentIdsDelete = [];
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Operation failed!!!');
      });
    this.setState({ hideDialogAssignDelete: false });
  }
  public dlgButtonClick(): void {
    this.setState({ hideDialog: false });
  }
  private setTeamTradeDialog(value: boolean): void {
    this.setState({ tradeTeamSetVisible: value });
  }
  public dlgButtonClickAssignCrud(): void {
    this.setState({ hideDialogAssignAdd: false });
  }
  private dialogCloseAssignCrud(): void {
    this.setState({ hideDialogAssignAdd: false });
  }
  private dialogOpenAssignCrud(): void {
    this.setState({ hideDialogAssignAdd: true });
  }
  componentDidMount() {
    this.getAssignments();
    let templateName: any = [];

    // $('#maskedTextBoxSearch').val('Search...');
  }
  componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ): void {
    if (this.context.isDataChangeTeam) {
      this.context.setDataChangeTeam(false);
    }
  }
  private getAssignments() {
    getAssignments().then((result) => {
      this.setState({
        AssignmentData: result.data,
        fields: {
          dataSource: result.data,
          id: 'assignment_id',
          text: 'full_name',
          hasChildren: 'hasChild',
          selected: 'isSelected',
        },
      });
    });
  }
  nodeclicked(args: any) {
    const assignmentId = args.node.getAttribute('data-uid');
    this.assignmentId = assignmentId;
    let assignName = this.filterAssignmentName(
      this.state.AssignmentData,
      assignmentId
    );
    this.selectedName = assignName;
  }
  menuclick = async (args: any) => {
    if (args.item !== undefined) {
      if (
        args.item.text === 'Assign Shift Element' ||
        args.item.text === 'Assign Note'
      ) {
        loadingShow(true, 'Preparing...');
        if (this.treeObj.getAllCheckedNodes().length > 0) {
          this.assignmentId = this.treeObj.getAllCheckedNodes().toString();
        }
        if (args.item.text === 'Assign Note') {
          this.setState({ isNoteMode: true });
        } else {
          this.setState({ isNoteMode: false });
        }
        getAssignmentsDetails(this.assignmentId)
          .then((response) => {
            loadingShow(false, 'Preparing...');
            this.setState({
              selectedAssignments: response.data,
              hideDialog: true,
            });
          })
          .catch((e: any) => {
            //(e);
            toast.error('Error occured.Please try again later');
            loadingShow(false, 'Preparing...');
          });
      } else if (args.item.text === 'Set Teams Trades') {
        loadingShow(true, 'Preparing...');
        this.setState({
          tradeTeamSetVisible: true,
        });
      }
    }
  };
  nodeChecked(args: any) {
    Scheduler.StoreAssign = [];
    Scheduler.StoreAssign.push(...this.checkedNodes);
  }
  changeDataSource(data: any) {
    this.setState({
      fields: {
        dataSource: data,
        id: 'assignment_id',
        text: 'full_name',
        hasChildren: 'hasChild',
        selected: 'isSelected',
      },
    });
  }
  searchNodes(args: any) {
    searchNodes(
      args.value,
      this.state.AssignmentData,
      this.changeDataSource.bind(this),
      'alias_name',
      'assignment_id'
    );
  }
  getFilterItems(fList: any, list: any): any {
    let nodes = [];
    nodes.push(fList['assignment_id']);
    let query2 = new Query().where(
      'assignment_id',
      'equal',
      fList['pid'],
      false
    );
    let fList1 = new DataManager(list).executeLocal(query2);
    if (fList1.length !== 0) {
      let pNode: any = this.getFilterItems(fList1[0], list);
      for (let i = 0; i < pNode.length; i++) {
        if (nodes.indexOf(pNode[i]) === -1 && pNode[i] != null)
          nodes.push(pNode[i]);
      }
      return nodes;
    }
    return nodes;
  }
  //#region ForFilter
  filterAssignmentName(input: any, id: any) {
    let assignmentName = input.filter((item: any) => {
      return item.assignment_id == id;
    });
    return assignmentName[0]['full_name'];
  }
  //#endregion
  //#region Assingment ve Exception
  //#endregion
  AddAssignOpenModal = () => {
    this.addAssignName = '';
    this.addAssignLastname = '';
    this.dialogOpenAssignCrud();
  };
  EditAssignOpenModal = () => {
    const theObj = this.treeObj as TreeViewComponent;
    //getAllCheckedNodes
    console.log("theobj: ", theObj)
    if (theObj.getAllCheckedNodes().length > 0) {
      if (theObj.getAllCheckedNodes().length === 1) {
        this.assignmentIdEdit = Number(theObj.getAllCheckedNodes()[0]);
        loadingShow(true, 'Preparing...');
        getAssignmentsDetails(this.assignmentIdEdit)
          .then((e) => {
            this.editAssignLastname = e.data.last_name;
            this.editAssignName = e.data.first_name;
            loadingShow(false);
            this.setState({ hideDialogAssignEdit: true });
          })
          .catch((e) => {
            Message.error('Error occured');
            loadingShow(false);
            //(e);
          });
      } else {
        Message.error('No allowed editted on multi selection mode');
      }
    } else {
      Message.error('No selected any tradeperson');
    }
  };
  DeleteAssignOpenModal = () => {
    if (this.treeObj?.getAllCheckedNodes().length > 0) {
      this.treeObj.getAllCheckedNodes().map((checkedNode:any)=>{
        this.assignmentIdsDelete.push(Number(checkedNode));
      })
      this.setState({ hideDialogAssignDelete: true });
    } else {
      Message.error('No selected any tradeperson to delete');
    }
  };
  //#region SetTeamTrades
  //#endregion

  //#region template
  //#endregion
  setChangeData = (value: boolean) => {
    this.context.setDataChange(value);
  };
  getAssignImage(value: any) {
    // var name = value;
    // var image =
    //   process.env.REACT_APP_API_GLOBAL_URL+'static/media/people/' + name;

    // if (name === '') image = defaultImage;
    return defaultImage;
  }
  TreeAssignRenderTemplate = (val: any) => {
    return (
      <div className='render-assign-tree'>
        <img className='eimage' src={this.getAssignImage(val.IMG_URL)}></img>
        <div className='ename'>{val.alias_name}</div>
      </div>
    );
  };
  setTradeTeamAffected = () => {
    this.context.setDataChangeTrade(true);
    this.context.setDataChangeTeam(true);
    this.context.setDataChange(true);
  };
  render() {
    return (
      <div>
        <div className='assignments-header-crud'>
          <h5 className='assignments-baslik'>TRADESPERSON</h5>
          <div className='assignment-crud'>
            <div className='add-assignment'>
              <IoAddSharp onClick={this.AddAssignOpenModal} size={17} />
            </div>
            <div className='edit-assignment'>
              <GoPencil onClick={this.EditAssignOpenModal} size={17} />
            </div>
            <div className='delete-assignment'>
              <IoTrashOutline onClick={this.DeleteAssignOpenModal} size={17} />
            </div>
            <div className='refresh-assignment'>
              <IoRefresh
                onClick={() => {
                  this.checkedNodes = [];
                  Scheduler.StoreAssign = [];
                  this.treeObj.uncheckAll();

                  this.getAssignments();
                  this.context.setDataChangeAssignment(false);
                }}
                size={17}
              />
            </div>
            <div className='uncheck-assignment'>
              <IoCheckmarkDoneOutline
                onClick={() => {
                  this.checkedNodes = [];
                  Scheduler.StoreTrades = [];
                  this.treeObj.uncheckAll();
                }}
                size={17}
              />
            </div>
          </div>
        </div>
        <div className='searchAssign'>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              alignSelf: 'flex-end',
              height: 25,
            }}
          >
            <TextBoxComponent
              type={'text'}
              id='assignment_search'
              autocomplete='off'
              // input={this.searchNodes.bind(this)}
              showClearButton
              placeholder='Search'
              onChange={this.searchNodes.bind(this)}
            />
            <div
              style={{
                borderRightColor: 'transparent',
                borderTopColor: 'transparent',
                borderBottomColor: 'transparent',
              }}
            ></div>
          </div>
        </div>
        <div className='assignments-treeview'>
          <div className='overflow-assign-treeview'>
            <div id='tree'>
              <TreeViewComponent
                id='treeAssign'
                fields={this.state.fields}
                ref={(treeview: TreeViewComponent) => {
                  this.treeObj = treeview;
                }}
                nodeClicked={this.nodeclicked.bind(this)}
                showCheckBox={this.isChecked}
                nodeChecked={this.nodeChecked}
                allowDragAndDrop={false}
                dragArea={
                  document.getElementById('SplitterInner') as HTMLElement
                }
                nodeTemplate={this.TreeAssignRenderTemplate}
              />
              <ContextMenuComponent
                id='contentmenutree'
                target='#tree'
                items={this.menuItems}
                select={this.menuclick.bind(this)}
                ref={(contextmenu) => {
                  this.menuObj = contextmenu;
                }}
              />
              <div className='control-pane-dialog'>
                <div
                  id='targetElement'
                  className='col-lg-12 defaultDialog dialog-target'
                >
                  <div>
                    {this.state.hideDialog ? (
                      <GenerateCapacity
                        assignments={this.state.selectedAssignments}
                        hideDialog={this.state.hideDialog}
                        isNoteMode={this.state.isNoteMode}
                        setHideDialogCapacity={(val) =>
                          this.setState({ hideDialog: val })
                        }
                      />
                    ) : null}
                  </div>
                  {this.state.tradeTeamSetVisible ? (
                    <TeamAndTradeSetter
                      affected={this.setTradeTeamAffected}
                      assignment_list={
                        Scheduler.StoreAssign.length > 0
                          ? Scheduler.StoreAssign
                          : [this.assignmentId]
                      }
                      hideDialogOrder={this.state.tradeTeamSetVisible}
                      setHideDialogSetter={this.setTeamTradeDialog.bind(this)}
                    />
                  ) : null}
                </div>
              </div>
              <div className='control-pane-dialogAdd'>
                <div
                  id='targetElementAddAssign'
                  className='col-lg-12 defaultDialogAddAssign dialog-target'
                >
                  {this.state.hideDialogAssignAdd ? (
                    <DialogComponent
                      isModal={true}
                      id='defaultDialogAddAssign'
                      showCloseIcon={true}
                      animationSettings={this.animationSettings}
                      visible={this.state.hideDialogAssignAdd}
                      width={'400px'}
                      height={'auto'}
                      header='Tradesperson'
                      buttons={[
                        {
                          click: () => {
                            this.addAssignElement();
                          },
                          buttonModel: {
                            content: 'Save',
                            isPrimary: true,
                            disabled: this.state.disabledAssignModal,
                          },
                        },
                        {
                          click: () => {
                            this.setState({ hideDialogAssignAdd: false });
                          },
                          buttonModel: {
                            content: 'Cancel',
                          },
                        },
                      ]}
                      open={this.dialogOpenAssignCrud.bind(this)}
                      close={this.dialogCloseAssignCrud.bind(this)}
                    >
                      <div className='row mb-3'>
                        <div className='col-md-3'>First Name:</div>
                        <div className='col-md-9'>
                          <TextBoxComponent
                            placeholder='Enter  Name'
                            value={this.addAssignName}
                            onChange={(e: any) => {
                              this.addAssignName = e.value;
                            }}
                          />
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className='col-md-3'>Last Name:</div>
                        <div className='col-md-9'>
                          <TextBoxComponent
                            placeholder='Enter Last Name'
                            value={this.addAssignLastname}
                            onChange={(e: any) => {
                              this.addAssignLastname = e.value;
                            }}
                          />
                        </div>
                      </div>

                      <div className='row mb-3'>
                        <div className='col-md-3'>Image</div>
                        <div className='col-md-9'>
                          <UploaderComponent
                            multiple={false}
                            allowedExtensions='.jpg,.png'
                            directoryUpload={false}
                          />
                        </div>
                      </div>
                    </DialogComponent>
                  ) : null}

                  {this.state.hideDialogAssignEdit ? (
                    <DialogComponent
                      isModal={true}
                      id='defaultDialogAddAssign'
                      showCloseIcon={true}
                      animationSettings={this.animationSettings}
                      visible={this.state.hideDialogAssignEdit}
                      width={'400px'}
                      height={'auto'}
                      header='Edit Tradesperson'
                      buttons={[
                        {
                          click: () => {
                            this.editAssignElement();
                          },
                          buttonModel: {
                            content: 'Save',
                            isPrimary: true,
                            disabled: this.state.disabledAssignModal,
                          },
                        },
                        {
                          click: () => {
                            this.setState({ hideDialogAssignEdit: false });
                          },
                          buttonModel: {
                            content: 'Cancel',
                          },
                        },
                      ]}
                      open={() => {
                        this.setState({ hideDialogAssignEdit: true });
                      }}
                      close={() => {
                        this.setState({ hideDialogAssignEdit: false });
                      }}
                    >
                      <div className='row mb-3'>
                        <div className='col-md-3'>First Name:</div>
                        <div className='col-md-9'>
                          <TextBoxComponent
                            placeholder='Enter  Name'
                            value={this.editAssignName}
                            onChange={(e: any) => {
                              this.editAssignName = e.value;
                            }}
                          />
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className='col-md-3'>Last Name:</div>
                        <div className='col-md-9'>
                          <TextBoxComponent
                            placeholder='Enter Last Name'
                            value={this.editAssignLastname}
                            onChange={(e: any) => {
                              this.editAssignLastname = e.value;
                            }}
                          />
                        </div>
                      </div>

                      <div className='row mb-3'>
                        <div className='col-md-3'>Image</div>
                        <div className='col-md-9'>
                          <UploaderComponent
                            multiple={false}
                            allowedExtensions='.jpg,.png'
                            directoryUpload={false}
                          />
                        </div>
                      </div>
                    </DialogComponent>
                  ) : null}

                  {this.state.hideDialogAssignDelete ? (
                    <DialogComponent
                      isModal={true}
                      id='defaultDialogAddAssign'
                      showCloseIcon={true}
                      animationSettings={this.animationSettings}
                      visible={this.state.hideDialogAssignDelete}
                      width={'400px'}
                      height={'auto'}
                      header='Delete Tradesperson'
                      buttons={this.buttonsAssignmentsDelete}
                      open={() => {
                        this.setState({ hideDialogAssignDelete: true });
                      }}
                      close={() => {
                        this.setState({ hideDialogAssignDelete: false });
                      }}
                    >
                      <p>Are you sure?</p>
                    </DialogComponent>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Assignments;
